import React, { FC } from 'react'
import { Divider, makeStyles } from 'transfix-ui/core'
import { rateTypeLabel } from 'apps/marketplace/pages/shippers/utils/shipperHelpers'
import { ShipperAccessorial } from 'apps/marketplace/pages/shippers/utils/types/shipperAccessorial'
import { CheckFilled, RejectedFilled } from 'components/atoms'
import { brandColors } from 'transfix-ui'

const useStyles = makeStyles(theme => ({
  item: {
    display: 'grid',
    placeItems: 'center',
    gripGap: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(0.5),
    width: '92px',
  },
  column: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'start',
    margin: '0 -1rem',
  },
  fee: {
    placeItems: 'start',
    gripGap: theme.spacing(1),
    width: 'max-content',
    margin: '1rem 0',
  },
  divdier: {
    background: brandColors.coolGray3,
  },
}))

interface IDetentionShipperAccessorial {
  accessorial: ShipperAccessorial
}

const RowItem = ({
  isRequired,
  label,
  value,
}: {
  label: string
  isRequired?: boolean | null
  value?: string
}) => {
  const classes = useStyles()

  return (
    <div className={classes.item}>
      <span>{label}</span>
      {isRequired ? (
        <CheckFilled className='large icon-active-blue xlarge' />
      ) : (
        value || <RejectedFilled className='large icon-disabled xlarge' />
      )}
    </div>
  )
}

const DetentionShipperAccessorial: FC<IDetentionShipperAccessorial> = ({ accessorial }) => {
  const {
    authNumberRequired,
    customerApprovalRequired,
    customerNotificationRequired,
    inOutTimesRequired,
    isStandardRate,
    podRequired,
    rate,
    rateType,
    receiptRequired,
    shipmentAccessorialName,
    taxIdRequired,
  } = accessorial

  const classes = useStyles()

  return (
    <div>
      <div className={classes.column}>
        <RowItem label='Notificaiton' isRequired={customerNotificationRequired} />
        <RowItem label='Approval' isRequired={customerApprovalRequired} />
        <RowItem label='In/Out Times' isRequired={inOutTimesRequired} />
        <RowItem label='POD' isRequired={podRequired} />
        <RowItem label='Tax ID' isRequired={taxIdRequired} />
        <RowItem label='Auth #' isRequired={authNumberRequired} />
        <RowItem label='Reciept' isRequired={receiptRequired} />
        <RowItem label='Standard Rate' isRequired={isStandardRate} />
      </div>
      <Divider className={classes.divdier} />
      <div className={`${classes.fee}`}>
        <strong>{shipmentAccessorialName}: </strong>
        <span>
          ${rate}
          {rateTypeLabel(rateType)}
        </span>
      </div>
    </div>
  )
}

export default DetentionShipperAccessorial
